/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { ContactSection } from "./ContactSection"
import { SectionGrid, Grid } from "frontend/src/components/Layout"

function Contact({ columns }) {
  return (
    <SectionGrid sx={{ pt: 7, pb: 8 }}>
      <SectionGrid.narrow>
        <Grid
          columns={["1fr", "1fr 1fr", "repeat(4,1fr)"]}
          gap={"20px"}
          sx={{ width: ["90%", "90%", "unset"], mx: "auto" }}
        >
          {columns.map((singleColumn, index) => (
            <ContactSection column={singleColumn} key={index} />
          ))}
        </Grid>
      </SectionGrid.narrow>
    </SectionGrid>
  )
}

export { Contact }
